import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Section = styled.section``;

export const Header = styled.div`
  margin-bottom: 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 24px;
  }
`;

export const Title = styled(Typography.Header)`
  margin: 0;
  font-size: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 20px;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 0 15px;
`;

export const Text = styled(Typography.Body)`
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.labels};
`;
